import { render, staticRenderFns } from "./SpinEdit.vue?vue&type=template&id=2c130c62&scoped=true&"
import script from "./SpinEdit.vue?vue&type=script&lang=js&"
export * from "./SpinEdit.vue?vue&type=script&lang=js&"
import style0 from "./SpinEdit.vue?vue&type=style&index=0&id=2c130c62&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2c130c62",
  null
  
)

export default component.exports